import type { BeautyFaqItem, BeautyPlan, BeautySimulatorSize } from "./beauty.types";

export const beautySimulatorSizes: BeautySimulatorSize[] = [
  {
    id: "solo",
    label: "Solo",
    professionals: 1,
    appointments: 80,
    ticket: 120,
    absenceRate: 18,
    description: "Profissional individual"
  },
  {
    id: "team",
    label: "Team",
    professionals: 3,
    appointments: 210,
    ticket: 130,
    absenceRate: 20,
    description: "Pequena equipe"
  },
  {
    id: "studio",
    label: "Studio",
    professionals: 8,
    appointments: 560,
    ticket: 145,
    absenceRate: 22,
    description: "Operação média"
  },
  {
    id: "studio-plus",
    label: "Studio+",
    professionals: 15,
    appointments: 1050,
    ticket: 155,
    absenceRate: 24,
    description: "Unidade em escala"
  }
];

export const beautyFaqs: BeautyFaqItem[] = [
  {
    question: "O cliente precisa criar conta para agendar?",
    answer:
      "Não. O cliente acessa o link, escolhe serviço, profissional quando habilitado e horário disponível. Nome e telefone são a base do agendamento; e-mail e cadastro completo podem ser estimulados sem travar a agenda."
  },
  {
    question: "A confirmação de presença é obrigatória?",
    answer:
      "Não. O estabelecimento decide se quer ativar confirmação de presença. Se ativar, também pode definir se um horário sem confirmação volta para a agenda com antecedência configurável."
  },
  {
    question: "Como o WhatsApp entra no fluxo?",
    answer:
      "Na versão inicial, o WhatsApp é tratado como apoio controlado para direcionar o cliente ao link de agendamento e evitar conversa manual repetitiva. Integrações mais avançadas entram por etapas."
  },
  {
    question: "Posso ter mais de um profissional?",
    answer:
      "Sim. No Team, cada profissional tem sua agenda. O cliente pode escolher um profissional específico ou agendar pelo primeiro horário disponível, conforme a configuração do estabelecimento."
  },
  {
    question: "Posso contratar profissionais extras sem trocar de plano?",
    answer:
      "Sim. A ideia é permitir adicionar profissionais avulsos como novas agendas dentro do mesmo estabelecimento. O plano não muda automaticamente: o THH GO pode mostrar o custo do profissional extra ou sugerir upgrade quando um plano maior for mais vantajoso."
  },
  {
    question: "O THH GO ajuda no controle de comissão?",
    answer:
      "A versão inicial já registra serviço, preço, profissional e status do atendimento. Isso deixa a operação preparada para relatório e cálculo de comissão em etapas seguintes."
  }
];

export const beautyPlans: BeautyPlan[] = [
  {
    id: "solo",
    name: "Solo",
    target: "Para autônomos e profissionais individuais",
    priceKey: "solo",
    annualNote: "standard",
    features: [
      { label: "1 profissional" },
      { label: "Agendamento online com link personalizado" },
      { label: "Disponibilidade em tempo real" },
      { label: "Agenda interna operacional" },
      { label: "Histórico de clientes" },
      { label: "Lembretes configuráveis" },
      { label: "Falta sem aviso registrada no histórico" },
      { label: "Avaliação pós-atendimento" },
      { label: "Painel de equipe", dimmed: true }
    ],
    cta: { label: "Começar 7 dias grátis", href: "/go/start", variant: "secondary" }
  },
  {
    id: "team",
    name: "Team",
    target: "Para salões com até 3 profissionais",
    priceKey: "team",
    variant: "featured",
    badge: "Mais popular",
    annualNote: "standard",
    features: [
      { label: "Tudo do plano Solo" },
      { label: "Até 3 profissionais" },
      { label: "Agenda por profissional" },
      { label: "Cliente pode escolher profissional, quando habilitado" },
      { label: "Painel unificado da equipe" },
      { label: "Base para comissão por profissional" },
      { label: "Bloqueio de horário por profissional" }
    ],
    cta: { label: "Começar 7 dias grátis", href: "/go/start", variant: "primary" }
  },
  {
    id: "studio",
    name: "Studio",
    target: "Para operações com até 10 profissionais na mesma unidade",
    priceKey: "studio",
    variant: "upcoming",
    badge: "Próxima etapa",
    annualNote: "assisted",
    monthlyNote: "Entrada com acompanhamento comercial",
    features: [
      { label: "Tudo do plano Team" },
      { label: "Até 10 profissionais na mesma unidade" },
      { label: "Visão operacional para equipes maiores" },
      { label: "Novas agendas conforme a equipe cresce" },
      { label: "Crescimento sem refazer cadastro ou histórico" }
    ],
    cta: { label: "Solicitar ativação assistida", href: "/go/start", variant: "secondary" }
  },
  {
    id: "studio-plus",
    name: "Studio+",
    target: "Para operações maiores, ainda em uma única unidade",
    priceKey: "studioPlus",
    variant: "upcoming",
    badge: "Entrada assistida",
    annualNote: "assisted",
    monthlyNote: "Até 20 profissionais por unidade",
    features: [
      { label: "Tudo do plano Studio" },
      { label: "Até 20 profissionais na mesma unidade" },
      { label: "Onboarding assistido para configurar a operação" },
      { label: "Sem multiunidade ou franquia nesta faixa" },
      { label: "Network continua como classe separada" }
    ],
    cta: { label: "Solicitar ativação assistida", href: "/go/start", variant: "secondary" }
  }
];
